import { useQuery } from "@tanstack/react-query";
import { SUBSCRIPTION_REQUEST_QUERY_KEYS } from "../configs/queryKeys";
import { SubscriptionRequestService } from "../services/subscriptionRequest.service";

export const useUpsellOfferQuery = (organizationId: string | null | undefined) =>
  useQuery({
    queryKey: organizationId
      ? SUBSCRIPTION_REQUEST_QUERY_KEYS.upsellOffer(organizationId)
      : ["upsell-offer", "disabled"],
    queryFn: () => SubscriptionRequestService.getUpsellOffer(organizationId as string),
    enabled: Boolean(organizationId),
    staleTime: 60_000,
  });
